import Portal from './Portal';
export default Portal;
